import React from 'react';
import { Link } from 'react-router-dom';
import styles from './AdminLayout.module.css';

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  return (
    <div className={styles.layoutContainer}>
      <header className={styles.header}>
        <div className={styles.headerLeft}>
          <span className={styles.logo}>Njordheim Admin</span>
        </div>
        <div className={styles.headerRight}>
          <Link to="/home" className={styles.backToGame}>
            ← Back to Game
          </Link>
        </div>
      </header>
      <div className={styles.contentArea}>
        {children}
      </div>
    </div>
  );
};

export default AdminLayout;
